export default __webpack_public_path__ + "static/media/red-arrow.844c1bff.svg";